import { render } from "./tw-ws-border.vue?vue&type=template&id=d48d607a"
import script from "./tw-ws-border.vue?vue&type=script&lang=js"
export * from "./tw-ws-border.vue?vue&type=script&lang=js"
script.render = render

export default script